// Configuration commerciale — à compléter avant la mise en ligne.
// Tant que checkoutUrl est vide, les boutons d'achat restent désactivés.
export const offer = {
  brand: "Petites Histoires, Grande Foi",
  productName: "Le Méga Pack de Paraboles Chrétiennes",
  price: "19,90 €",
  checkoutUrl: "",
  supportEmail: "",
};

export const legalLinks = [
  { label: "Mentions légales", href: "" },
  { label: "Conditions générales de vente", href: "" },
  { label: "Politique de confidentialité", href: "" },
  { label: "Politique de remboursement", href: "" },
];

// Visuels réels du produit — collez l'URL d'une image pour remplacer l'emplacement réservé.
export const productVisuals = {
  heroMockup: "",
  offerMockup: "",
};

export const lifestylePhotos = {
  readingTogether:
    "https://cdn.magicpatterns.com/patterns/generated-images/98e77a23-296e-467c-ad7b-227bc1c69c55.jpg",
  bedtimeStory:
    "https://cdn.magicpatterns.com/patterns/generated-images/9b35b843-cded-49b6-90fb-0aff20706f4f.jpg",
};
